import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Breadcrumbs,
  Typography,
  TextField,
  Container,
  Grid,
  Box,
  MenuItem,
  IconButton,
  Pagination,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { getName } from "../Other/common";
import { toast } from "react-toastify";
import { useTheme } from "@emotion/react";
import { Select, FormControl, InputLabel } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { BASE_URL } from "../../urlConfig/Url";

const AssetMaster = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [pendingQt, setPendingQt] = useState("");
  const [plantCode, setPlantCode] = useState("");
  const [assetC, setAssetC] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [deprec, setDeprec] = useState("");
  const [desrecDay, setDesrecDay] = useState("");
  const [quantitiy, setQuantity] = useState("");

  const [plantAddress, setPlantAddress] = useState("");

  const [status, setStatus] = useState("");


  // error states
  const [plantCodeError, setPlantCodeError] = useState(false);
  const [assetCError, setAssetCError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [categoryError, setCategoryError] = useState(false);
  const [deprecError, setDeprecError] = useState(false);
  const [desrecDayError, setDesrecDayError] = useState(false);
  const [quantitiyError, setQuantityError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  const [companies, setCompanies] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [cName, setCName] = useState([]);
  const [cNameTwo, setCNameTwo] = useState([]);
  const [formMode, setFormMode] = useState("initial");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    fetchCompanies();
    fetchCompaniesName();
    fetchCompaniesNameTwo();
  }, []);

  const fetchCompanies = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getAllAssetMaster"
      );
      if (response.data.success) {
        setCompanies(response.data.response);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesName = async () => {
    try {
      const response = await axios.post(BASE_URL + "/api/master/getPlantCode");
      if (response.data.success) {
        setCName(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const fetchCompaniesNameTwo = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/getAllCatagorycodeAssetMaster"
      );
      if (response.data.success) {
        setCNameTwo(response.data.response);
      }
    } catch (error) {
      toast.error("Error fetching company data:", error);
    }
  };

  const handleCategoryChange = async (e) => {
    const selectedCategory = e.target.value;
    setCategory(selectedCategory);

    try {
      const response = await axios.post(
        BASE_URL + "/api/master/searchByCatagoryCode",
        { catagoryCode: selectedCategory }
      );
      if (response.data.success && response.data.response.length > 0) {
        const { Depreciation, DepreciationYear } = response.data.response[0];
        setDeprec(Depreciation);
        setDesrecDay(DepreciationYear);
      }
    } catch (error) {
      toast.error("Error fetching category details:", error);
    }
  };

  const formvalidation = () => {
    let isValid = true;
    if (plantCode.trim() === "") {
      setPlantCodeError(true);
      isValid = false;
    }else {
      setPlantCodeError(false);
    }
    if (assetC.trim() === "") {
      setAssetCError(true);
      isValid = false;  
    }else {
      setAssetCError(false);
    }
    if (description.trim() === "") {
      setDescriptionError(true);
      isValid = false;
    }else {
      setDescriptionError(false);
    }
    if (deprec.trim() === "") {
      setDeprecError(true);
      isValid = false;
    }else {
      setDeprecError(false);
    }
    if (category.trim() === "") {
      setCategoryError(true);
      isValid = false;
    }else {
      setCategoryError(false);
    }
    if (desrecDay.trim() === "") {
      setDesrecDayError(true);
      isValid = false; 
    }else {
      setDesrecDayError(false);
    }
    if (quantitiy.trim() === "") {
      setQuantityError(true);
      isValid = false;  
    }else {
      setQuantityError(false);
    }
    if (status.trim() === "") {
      setStatusError(true);
      isValid = false;  
    }else {
      setStatusError(false);  
    }
    return isValid;

  }

  const onSubmit = async () => {
    if (formvalidation()) {
      
    
    const data = {
      PlantCode: plantCode,
      AssetCode: assetC,
      Description: description,
      Category: category,
      Depreciation: deprec,
      DepreciationYear: desrecDay,
      Quantity: quantitiy,
      Status: status,
      CreatedBy: getName().Name,
    };
    //   console.log(data);
    try {
      const response = await axios.post(
        BASE_URL + "/api/master/insertAssetDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        fetchCompanies();
        resetForm();
        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting company data:", error);
      toast.error("An error occurred while adding the company.");
    }
  }else {
    toast.error("Please fill all the fields");
  }
  };

  const onUpdate = async () => {
    const selectedRow = companies.find(
      (company) =>
        company.PlantCode === plantCode && company.AssetCode === assetC
    );

    if (!selectedRow) {
      toast.error("Selected item not found.");
      return;
    }

    const originalQuantity = parseInt(selectedRow.Quantity, 10);
    const originalPendingQt = parseInt(selectedRow.PendingQty, 10);
    const newQuantity = parseInt(quantitiy, 10);

    // Calculate the minimum allowed quantity
    const minAllowedQuantity = originalQuantity - originalPendingQt;

    if (newQuantity < minAllowedQuantity) {
      toast.error(
        "Total Qty should be greater than or equal to Printed Quantity"
      );
      return;
    }

    // Calculate the difference between new and original quantity
    const quantityDifference = newQuantity - originalQuantity;

    // Calculate the new pending quantity
    const newPendingQt = originalPendingQt + quantityDifference;

    // Ensure the new pending quantity is not negative
    if (newPendingQt < 0) {
      toast.error("New quantity would result in negative pending quantity.");
      return;
    }

    const data = {
      PlantCode: plantCode,
      AssetCode: assetC,
      Description: description,
      Category: category,
      Depreciation: deprec,
      DepreciationYear: desrecDay,
      Quantity: quantitiy,
      Status: status,
      PendingQty: newPendingQt,
      ModifiedBy: getName().Name,
    };

    try {
      const response = await axios.post(
        BASE_URL + "/api/master/updateAssetDetails",
        data
      );

      if (response.data.success) {
        toast.success(response.data.message);
        // Refetch the updated companies data
        await fetchCompanies();

        // Reset the form
        resetForm();

        setFormMode("initial");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating company data:", error);
      toast.error("An error occurred while updating the company.");
    }
  };

  const resetForm = () => {
    setPlantCode("");
    setAssetC("");
    setDescription("");
    setCategory("");
    setDeprec("");
    setDesrecDay("");
    setQuantity("");
    setStatus("");
    setQuantity("");
  };

  const handleAddNew = () => {
    setFormMode("add");
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    setFormMode("initial");
    stopErrorHelper();
  };

  useEffect(() => {
    const searchWords = searchTerm.toLowerCase().split(/\s+/).filter(Boolean);
    
    const result = companies.filter((company) =>
      searchWords.every((word) =>
        Object.entries(company).some(([key, value]) => {
          // Skip null or undefined values
          if (value == null) return false;
  
          // Convert to string and compare
          return value.toString().toLowerCase().includes(word);
        })
      )
    );
    setFilteredRows(result);
  }, [searchTerm, companies]);
  
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const stopErrorHelper=()=>{
    setPlantCodeError(false);
    setAssetCError(false);
    setDescriptionError(false);
    setCategoryError(false);
    setDeprecError(false);
    setDesrecDayError(false);
    setQuantityError(false);
    setStatusError(false);
  }

  const handleRowSelect = (company) => {
    setPlantCode(company.PlantCode);
    setAssetC(company.AssetCode);
    setDescription(company.Description);
    setCategory(company.Category);
    setDeprec(company.Depreciation);
    setDesrecDay(company.DepreciationYear);
    setQuantity(company.Quantity);
    setStatus(company.Status);
    setPendingQt(company.PendingQty);
    setFormMode("edit");
    stopErrorHelper();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedRows = filteredRows.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 1, mb: 2 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              to="/dashboard/dashbordhome"
              style={{
                textDecoration: "none",
                color: theme.palette.primary.main,
              }}
            >
              Home
            </Link>
            <Typography color="textPrimary">Asset Master</Typography>
          </Breadcrumbs>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Typography variant="h6" mb={2} sx={{ textAlign: "left" }}>
              Asset Master (* Fields Are Mandatory)
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Plant Code (*)"
                  name="Plant Code"
                  fullWidth
                  size="small"
                  value={plantCode}
                  error={plantCodeError}
                  helperText={plantCodeError ? "Plant Code is required" : ""}
                  onChange={(e) => setPlantCode(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"} // Disable field if in view mode
                >
                  {cName.map((company) => (
                    <MenuItem key={company.PlantCode} value={company.PlantCode}>
                      {company.PlantCode}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Asset Code (*)"
                  name="AssetCode"
                  fullWidth
                  size="small"
                  value={assetC}
                  error={assetCError}
                  helperText={assetCError ? "Asset Code is required" : ""}
                  onChange={(e) => setAssetC(e.target.value)}
                  disabled={formMode === "initial" || formMode === "edit"} // Disable field if in view mode
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  label="Description (*)"
                  name="Description"
                  fullWidth
                  size="small"
                  value={description}
                  error={descriptionError}
                  helperText={
                    descriptionError ? "Description is required" : ""
                  
                  }
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Category (*)"
                  name="Category"
                  fullWidth
                  size="small"
                  value={category}
                  error={categoryError}
                  helperText={categoryError ? "Category is required" : ""}
                  onChange={handleCategoryChange}
                  disabled={formMode === "initial"}
                >
                  {cNameTwo.map((company) => (
                    <MenuItem
                      key={company.CategoryCode}
                      value={company.CategoryCode}
                    >
                      {company.CategoryCode}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Depreciation  (*)"
                  name="Depreciation"
                  fullWidth
                  size="small"
                  value={deprec}
                  error={deprecError}
                  helperText={deprecError ? "Depreciation is required" : ""}
                  onChange={(e) => setDeprec(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Depreciation Days (*)"
                  name="Depreciation Days"
                  fullWidth
                  size="small"
                  value={desrecDay}
                  error={desrecDayError}
                  helperText={desrecDayError ? "Depreciation Days is required" : ""}
                  onChange={(e) => setDesrecDay(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Quantity (*)"
                  name="Quantity"
                  fullWidth
                  size="small"
                  value={quantitiy}
                  error={quantitiyError}
                  helperText={quantitiyError ? "Quantity is required" : ""}
                  onChange={(e) => setQuantity(e.target.value)}
                  disabled={formMode === "initial"}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="Status(*)"
                  name="Status"
                  fullWidth
                  size="small"
                  value={status}
                  error={statusError}
                  helperText={statusError ? "Status is required" : ""}
                  onChange={(e) => setStatus(e.target.value)}
                  disabled={formMode === "initial"}
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Deactive">Deactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" mt={5} spacing={1}>
              {formMode === "initial" && (
                <Grid item>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddNew}
                  >
                    <AddIcon />
                    Add New
                  </Button>
                </Grid>
              )}

              {formMode === "add" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onSubmit}>
                      <AddIcon />
                      Submit
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}

              {formMode === "edit" && (
                <>
                  <Grid item>
                    <Button variant="contained" size="small" onClick={onUpdate}>
                      <ChangeCircleIcon />
                      Update
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCancel}
                    >
                      <CloseIcon />
                      Cancel
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>
          </Paper>
        </Box>

        <Box sx={{ mt: 3, overflowX: "auto" }}>
          <Paper elevation={3} sx={{ padding: "2%" }}>
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                sx={{ minWidth: 100 }}
              >
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                  labelId="rows-per-page-label"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  label="Rows per page"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Search"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{ width: 250 }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />
            </Box>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Plnat Code</th>

                    <th>Asset Code</th>
                    <th>Description</th>
                    <th>Category</th>
                    <th>Depreciation</th>
                    <th>Depreciation Year</th>
                    <th>Quantity</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Modified By</th>
                    <th>Modified Date</th>
                    <th>Pending Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRows.map((company) => (
                    <tr key={company.ID}>
                      <td data-label="Select">
                        <button onClick={() => handleRowSelect(company)}>
                          Select
                        </button>
                      </td>
                      <td data-lable="Plnat Code">{company.PlantCode}</td>
                      <td data-lable="Description">{company.AssetCode}</td>
                      <td data-lable="Asset Code">{company.Description}</td>
                      <td data-lable="Category">{company.Category}</td>
                      <td data-lable="Depreciation">{company.Depreciation}%</td>
                      <td data-lable="Depreciation Year">
                        {company.DepreciationYear}
                      </td>
                      <td data-lable="Quantity">{company.Quantity}</td>
                      <td data-lable="Status">{company.Status}</td>
                      <td data-lable="Created By">{company.CreatedBy}</td>
                      <td data-lable="Created Date">
                        {new Date(company.CreatedDate).toLocaleString()}
                      </td>
                      <td data-lable="Modified By">{company.ModifiedBy}</td>
                      <td data-lable="Modified Date">
                        {company.ModifiedDate
                          ? new Date(company.ModifiedDate).toLocaleString()
                          : ""}
                      </td>
                      <td data-lable="Pending Qty">{company.PendingQty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ marginRight: 2 }}>
                Showing {(page - 1) * rowsPerPage + 1} to{" "}
                {Math.min(page * rowsPerPage, filteredRows.length)} of{" "}
                {filteredRows.length} entries
              </Typography>
              <Pagination
                count={Math.ceil(filteredRows.length / rowsPerPage)}
                page={page}
                onChange={handleChangePage}
                size="small"
              />
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default AssetMaster;
